import manTxt from "./man.txt"
import refTxt from "./ref.txt"
import typingTxt from "./typing.txt"
import codeTxt from "./code.txt"

export const userland = {
  "ls": `\
for (let filename of Object.keys(files)) {
  console.log(filename);
}
`,
  "cat": `
if (argv.length === 1) {
  console.log("Usage: cat <file>");
} else {
  console.log(read(argv[1]));
}
`,
  "man.txt": manTxt,
  "ref.txt": refTxt,
  "typing.txt": typingTxt.replaceAll("∫", "\b")
                         .replaceAll("®", "\x0E")
                         .replaceAll("µ", "\x0F")
                         .replaceAll("√", "\x07"),
  "code.txt": codeTxt
}
